import { CheckBoxIcon, CheckBoxOutlineBlankIcon } from 'components/uiIcons';
import ShowItemTableRow from 'components/item/show_item_table_row';

const icon = (field) => {
  if (field.value) {
    return <CheckBoxIcon />;
  } else {
    return <CheckBoxOutlineBlankIcon />;
  }
};

const Index = ({ inspectionFields, showValues = true }) => {

  return (
    <>
      {inspectionFields.map((field) => (
        <ShowItemTableRow key={field.name} label={field.name} emptyComponent="">
          {showValues && icon(field)}
        </ShowItemTableRow>
      ))}
    </>
  );
};

export default Index;
